export default "__VITE_ASSET__977d5e62__"